import React from "react";
import { motion, useInView } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, className = "", y = 40, ...rest }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px -10% 0px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 1, ease, delay }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal
export function MaskLines({ lines, className = "", lineClass = "", delay = 0, animate = true }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            initial={{ y: "110%" }}
            animate={animate ? { y: "0%" } : {}}
            transition={{ duration: 1.1, ease, delay: delay + i * 0.12 }}
            className={lineClass}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
}

export function Word({ children, className = "", delay = 0 }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10%" });
  return (
    <span ref={ref} className="inline-block overflow-hidden align-bottom">
      <motion.span
        initial={{ y: "110%" }}
        animate={inView ? { y: "0%" } : {}}
        transition={{ duration: 1, ease, delay }}
        className={"inline-block " + className}
      >
        {children}
      </motion.span>
    </span>
  );
}
